import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy: React.FC = () => {
  return (
    <main className="privacy-content">
      <h1>Privacy Policy</h1>
      <p>
        Your privacy is important to us. This privacy statement explains that our app does not
        collect any personal data or require users to register an account.
      </p>
      <h2>No Data Collection</h2>
      <p>
        Our app is designed to function without collecting any personal information from users. We
        do not require you to provide your name, email address, or any other personal details to use
        the app.
      </p>
      <h2>No Account Registration</h2>
      <p>
        You can use all features of our app without the need to create an account or log in. This
        ensures that your personal information remains private and secure.
      </p>
      <h2>Feedback and Support</h2>
      <p>
        While we do not collect user data, we welcome any feedback or questions you may have. Feel
        free to contact us at: <a href="mailto:sl842378991@gmail.com">sl842378991@gmail.com</a>
      </p>
      <p>Thank you for using DriveSmart Prep!</p>
    </main>
  );
};

export default PrivacyPolicy;
